import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { Season } from '@lcc/shared';
import { api } from './api';

/** The current season, needed by nearly every screen. */
export function useCurrentSeason() {
  return useQuery({
    queryKey: ['season', 'current'],
    queryFn: () => api.get<{ data: Season }>('/seasons/current').then((r) => r.data),
    staleTime: 60 * 60_000,
  });
}

/** Debounces a value, for search boxes that would otherwise fire per keystroke. */
export function useDebounced<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
}
